import store from '@/store';

export default {
  removeAll() {
    store.getters.manageFontSizesClasses.forEach((fontSizeClass) => {
      document.documentElement.classList.remove(fontSizeClass);
    });
  },
  setClass(fontClass) {
    this.removeAll();
    document.documentElement.classList.add(fontClass);
  },
};
